import { connect } from 'react-redux'
import WorksTable from './works-table'
import { getWorksList } from '../../../../../stores/works/works.selectors'

const mapStateToProps = state => {
  const works = getWorksList(state)
  return {
    works: works,
    noWorks: !works.length
  }
}

export default connect(
  mapStateToProps,
  null
)(WorksTable)
